var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictureCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24 49V25C24 24.6022 24.158 24.2206 24.4393 23.9393C24.7206 23.658 25.1022 23.5 25.5 23.5H55.5C55.8978 23.5 56.2794 23.658 56.5607 23.9393C56.842 24.2206 57 24.6022 57 25V46L57 46L49.0607 38.0607C48.7793 37.7794 48.3978 37.6213 48 37.6213C47.6022 37.6213 47.2206 37.7794 46.9393 38.0607L38.5607 46.4393C38.2793 46.7206 37.8978 46.8787 37.5 46.8787C37.1022 46.8787 36.7206 46.7206 36.4393 46.4393L32.5607 42.5607C32.2793 42.2793 31.8978 42.1213 31.5 42.1213C31.1022 42.1213 30.7206 42.2793 30.4393 42.5607L24 49Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 23.5H25.5C24.6716 23.5 24 24.1716 24 25V55C24 55.8284 24.6716 56.5 25.5 56.5H55.5C56.3284 56.5 57 55.8284 57 55V25C57 24.1716 56.3284 23.5 55.5 23.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46.0037L49.0607 38.0643C48.7793 37.783 48.3978 37.625 48 37.625C47.6022 37.625 47.2206 37.783 46.9393 38.0643L38.5607 46.443C38.2793 46.7243 37.8978 46.8824 37.5 46.8824C37.1022 46.8824 36.7206 46.7243 36.4393 46.443L32.5607 42.5643C32.2793 42.283 31.8978 42.125 31.5 42.125C31.1022 42.125 30.7206 42.283 30.4393 42.5643L24 49.0037",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 35.5C36.4926 35.5 37.5 34.4926 37.5 33.25C37.5 32.0074 36.4926 31 35.25 31C34.0074 31 33 32.0074 33 33.25C33 34.4926 34.0074 35.5 35.25 35.5Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureCircleIcon);
export default __webpack_public_path__ + "static/media/picture_circle_icon.b6a00959a6173f7e6209437f7426252d.svg";
export { ForwardRef as ReactComponent };